import { brand, global } from '../../fuse-colours/src/colours';
import { fontFamily } from '../../fuse-typography/src/typography';

// Multiplier set to 1.6 due to root font-size of page being 10px and rounding to 1 decimal place
const rootFontSizeMultiplier = 1.6;

const { littlewoods, very } = brand;

const sharedViewportHeadingSize = {
	xxs: {
		h1: '5',
		h2: '4',
		h3: '3',
		h4: '2',
		h5: '1',
		h6: 'M1',
	},
	m: {
		h1: '6',
		h2: '5',
		h3: '4',
		h4: '3',
		h5: '2',
		h6: '1',
	},
	l: {
		h1: '7',
		h2: '6',
		h3: '5',
		h4: '4',
		h5: '3',
		h6: '2',
	},
};

/**
 * Default heading sizes for global theme component from h1 - h6 tags
 * Current config means heading sizes for both brands are the same and shared though this can be changed in the future
 */
const defaultHeading = {
	littlewoods: {
		...sharedViewportHeadingSize,
	},
	very: {
		...sharedViewportHeadingSize,
	},
};

const themesConfig = {
	default: {
		name: 'Default',
		color: {
			100: very.pink100,
			200: very.pink200,
			300: very.pink300,
			400: very.pink400,
			500: very.pink500,
			600: very.pink600,
			700: very.pink700,
			800: very.pink800,
			900: very.pink900,
			dark: very.pinkDark,
			mid: very.pinkMid,
			light: very.pinkLight,
			onBlack: very.onBlack,
			enhancedText: very.enhancedText,
		},
		dark: very.pinkDark,
		mid: very.pinkMid,
		light: very.pinkLight,
		baseFontColour: global.grey900,
		fontFamily: fontFamily.very,
		defaultHeading: defaultHeading.very,
	},
	littlewoods: {
		name: 'Fuse Littlewoods',
		color: {
			100: littlewoods.purple100,
			200: littlewoods.purple200,
			300: littlewoods.purple300,
			400: littlewoods.purple400,
			500: littlewoods.purple500,
			600: littlewoods.purple600,
			700: littlewoods.purple700,
			800: littlewoods.purple800,
			900: littlewoods.purple900,
			dark: littlewoods.purpleDark,
			mid: littlewoods.purpleMid,
			light: littlewoods.purpleLight,
			onBlack: littlewoods.onBlack,
			enhancedText: littlewoods.enhancedText,
		},
		dark: littlewoods.purpleDark,
		mid: littlewoods.purpleMid,
		light: littlewoods.purpleLight,
		baseFontColour: global.grey900,
		fontFamily: fontFamily.littlewoods,
		defaultHeading: defaultHeading.littlewoods,
	},
	very: {
		name: 'Fuse Very',
		color: {
			100: very.pink100,
			200: very.pink200,
			300: very.pink300,
			400: very.pink400,
			500: very.pink500,
			600: very.pink600,
			700: very.pink700,
			800: very.pink800,
			900: very.pink900,
			dark: very.pinkDark,
			mid: very.pinkMid,
			light: very.pinkLight,
			onBlack: very.onBlack,
			enhancedText: very.enhancedText,
		},
		dark: very.pinkDark,
		mid: very.pinkMid,
		light: very.pinkLight,
		baseFontColour: global.grey900,
		fontFamily: fontFamily.very,
		defaultHeading: defaultHeading.very,
	},
};

export default themesConfig;
export { defaultHeading, rootFontSizeMultiplier, themesConfig };
